import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResultComponentDef } from '@df/ui/api/result.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

/**
 * `result` shows action results and hides them after a while
 *
 *
 * ## usage
 * ```html
 * <result [status]="status" ></result>
 * ```
 */
@Component({
    selector: 'result',
    templateUrl: './result.html',
    standalone: true,
    imports: [NgClass, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultComponent extends ResultComponentDef {
    @Input()
    customClasses?: string;
}
